import React from 'react';
export default function Chip({ label, onClick, color = "bg-gray-200" }) {
    return (<span onClick={onClick}
        className={`px-2 m-1 py-1 rounded-full  font-semibold text-xs flex align-center w-max  active:bg-gray-300 transition duration-300 ease ${color} text-gray-500`}>
        {label}
    </span>)
}